import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

import img1 from '@/assets/images/fun-zone-img1.webp';
import img2 from '@/assets/images/fun-zone-img2.webp';
import img3 from '@/assets/images/fun-zone-img3.webp';

import styles from './FunZone.module.scss';

function FunZone() {
  gsap.registerPlugin(ScrollTrigger);

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const imagesCard = [
    { text: 'Яркая атмосфера праздника и весёлые активности для любого возраста', img: img1 },
    { text: 'Драйвовая музыка от диджея и энергичный ведущий', img: img2 }, { text: 'Целый день уникальных эмоций', img: img3 },
  ];

  gsap.set(`.${styles.card}`, { y: 100 });

  ScrollTrigger.batch(`.${styles.card}`, {
    interval: 0.5,
    batchMax: 1,
    onEnter: batch => gsap.to(batch, { opacity: 1, y: 0, duration: 1.5, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
    onLeaveBack: batch => gsap.set(batch, { opacity: 0, y: 100, duration: 1.5, overwrite: true }),
  });


  return (
    <section className={styles.funZone}>
      <p className={styles.suptitle}>Всех участников и болельщиков ждёт&nbsp;грандиозная</p>
      <h2 className={styles.title}>фан-зона, которая точно не даст заскучать</h2>
      <p className={styles.subtitle}>вход свободный</p>

      <div className={styles.main} style={{ position: 'relative' }}>
        <div className={styles.wrapper} >
          <div className={styles.sloganWrap}>
            <p className={styles.slogan}>ЗАБЕГ — это праздник для всей семьи!</p>
            {!isMobile && (
              <a className={styles.anchor} href="#formats">
                Участвовать!
              </a>
            )}
          </div>
        </div>

        <div className={styles.cards}>
          {imagesCard.map((el, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.imgWrap}>
                <img className={`${styles.cardImg} lazyload`} src={el.img} width={644} height={308} alt="" />

              </div>
              <p className={styles.cardText}>{el.text}</p>
            </div>
          ))}
        </div>

        {isMobile && (
          <a className={`${styles.anchor} ${styles.mobileBtn}`} href="#">
            Участвовать!
          </a>
        )}
      </div>
    </section>
  );
}

export default FunZone;
